/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weighing_Ballot_ReturnedInputs */

const vi_weighing_ballot_returned = /** @type {(inputs: Weighing_Ballot_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã trả phiếu`)
};

/**

* @param {Weighing_Ballot_ReturnedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const weighing_ballot_returned = /** @type {((inputs?: Weighing_Ballot_ReturnedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weighing_Ballot_ReturnedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_weighing_ballot_returned(inputs)
});